<template>
  <div no-body class="lku-salesae">
    <b-row v-if="lkuLoading" class="justify-content-center mb-2">
      <span style="color:blue;">Loading data ...</span>
    </b-row>
    <b-row v-else>
      <b-col lg="9">
        <b-form-group
          style="margin-bottom:-4px !important;"
          horizontal
          label="Filter"
          label-cols="1"
        >
          <b-row>
            <b-col class="pr-1" cols="3">
              <b-form-input
                v-model="tblData.code"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Cust Code"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.name"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Cust Name"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.customer_group"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="customer group"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.SalesCode"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Sales Code"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group style="margin-bottom:-4px !important;" horizontal>
          <b-row>
            <b-button class="btn btn-success mr-1" @click="refresh()" size="sm">
              <i class="fa fa-search"></i> Search
            </b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblKoranCust"
      responsive
      striped
      hover
      small
      style="font-size:smaller;"
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
    >
      <template
        slot="requestdate"
        slot-scope="data"
      >{{ data.item.requestdate | moment("DD MMM YYYY") }}</template>
      <template
        slot="quantity"
        slot-scope="data"
      >{{data.item.quantity}} &nbsp; {{data.item.unitsize}}</template>
      <template v-slot:cell(nilai)="data">
        <span v-if="(data.item.nilai)">{{data.item.matauang}} &nbsp;{{data.item.nilai|numFormat}}</span>
      </template>
      <template v-slot:cell(jasa)="data">
        <span v-if="(data.item.jasa)">Service</span>
        <span v-else>Material</span>
      </template>
    </b-table>
    <b-row>
      <b-col cols="6">
        <div>
          Showing
          {{(tblData.page - 1) * tblData.limit + 1}}
          to
          {{tblData.page * tblData.limit}}
          of
          {{tblData.total}}
          entries
        </div>
      </b-col>
      <b-col cols="6">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.lku-adv {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import crud from "../../apis/crud";
import moment from 'moment';

export default {
  data() {
    return {
      items: [],
      fields: [
        {
          key: "crewnik",
          thStyle: "width:100px",
          label: "NIK"
        },
        {
          key: "salesae_name",
          label: "Sales Name",
          sortable: true
        },
        {
          key: "startdate",
          label: "Tanggal Mulai",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        }
      ],
      tblData: {
        tablename: "vwsalesae",
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
        outstand: "1"
      },
      lkuLoading: false
    };
  },
  props: ["filter"],
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await crud.list(this.tblData);
      list.forEach((el,idx) => {
          list[idx].tanggal = moment(el.tanggal).format('YYYY-MM-DD')
          list[idx].startdate = moment(el.startdate).format('YYYY-MM-DD')
          list[idx].enddate = moment(el.enddate).format('YYYY-MM-DD')
      });
      return list;
    },

    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData.name = "";
      this.tblData.code = "";
      this.tblData.customer_group = "";
      this.tblData.SalesCode = "";
      this.refresh();
    },
    refresh: async function() {
      this.$refs.tblKoranCust.refresh();
    }
  }
};
</script>
